import { useMutation } from '@tanstack/react-query';
import axios from '@/lib/axios';
import { Workspace } from '@/hooks/api/models';

/**
 * 0141. ワークスペース詳細情報編集
 * [PUT] /workspaces/:identifier/details
 */
type Props = {
  identifier: string;
  invoice_manual_url: string;
  consumption_tax_rule: string;
};
export const updateWorkspaceDetail = (props: Props): Promise<Workspace> => {
  return axios.put(`/api/workspaces/${props.identifier}/details`, props);
};

export const useUpdateWorkspaceDetail = () => {
  return useMutation({
    mutationFn: updateWorkspaceDetail,
  });
};
